import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useCanonical";
import { getStaticRouteSeo } from "@/lib/seo";

const workCategories = [
  { name: "Editorial", slug: "editorial" },
  { name: "Commissions", slug: "commissions" },
  { name: "Interior", slug: "interior" },
  { name: "Lifestyle", slug: "lifestyle" },
  { name: "Collage", slug: "collage" },
  { name: "Wedding", slug: "wedding" },
  { name: "Film", slug: "film" },
];

const NotFound = () => {
  const seo = getStaticRouteSeo("notFound");

  useSEO(seo);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />
      <main className="flex-1 flex items-center justify-center pt-32 pb-16 px-6">
        <div className="text-center max-w-md">
          <h1 className="text-8xl font-heading font-semibold text-foreground mb-4">404</h1>
          <p className="text-xl text-muted-foreground mb-8">
            Sidan du letar efter finns inte.
          </p>
          
          <div className="space-y-8">
            <div>
              <h2 className="text-xs uppercase tracking-wider text-muted-foreground mb-4 font-small-heading font-extrabold">
                Sidor
              </h2>
              <nav className="flex flex-wrap justify-center gap-4">
                <Link 
                  to="/" 
                  className="text-sm text-foreground hover:text-accent transition-colors underline underline-offset-4"
                >
                  Home
                </Link>
                <Link 
                  to="/hej-mamma" 
                  className="text-sm text-foreground hover:text-accent transition-colors underline underline-offset-4"
                >
                  Hej Mamma
                </Link>
                <Link 
                  to="/about" 
                  className="text-sm text-foreground hover:text-accent transition-colors underline underline-offset-4"
                >
                  About
                </Link>
                <Link 
                  to="/booking" 
                  className="text-sm text-foreground hover:text-accent transition-colors underline underline-offset-4"
                >
                  Booking
                </Link>
              </nav>
            </div>

            <div>
              <h2 className="text-xs uppercase tracking-wider text-muted-foreground mb-4 font-small-heading font-extrabold">
                Work
              </h2>
              <nav className="flex flex-wrap justify-center gap-4">
                {workCategories.map((category) => (
                  <Link
                    key={category.slug}
                    to={`/work/${category.slug}`}
                    className="text-sm text-foreground hover:text-accent transition-colors underline underline-offset-4"
                  >
                    {category.name}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
